<template>
  <div id="page-wrapper" v-if="loggedIn">
    <div class="section">
      <div class="section__status">
        <img src="/static/images/svgs/PaymentFailure.svg" class="section__status__image" />
        <p class="section__status__title">Payment Failed</p>
        <p class="section__status__subtitle">{{ responseMessage.responseDescription }}</p>
      </div>
      <router-link :to="{name:'Dashboard'}">
        <ActionButton title="Go Home" />
      </router-link>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ActionButton from "@/components/ActionButton/index";

export default {
  name: "EplNewTransactionFail",
  props: ["responseMessage"],
  computed: {
    ...mapGetters(["loggedIn", "selectedPlan", "bbpsImages", "serviceType"])
  },
  components: { ActionButton },
  methods: {},
  mounted() {
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "TRANSACTED",
      propertyName: "TRANSACTION_TYPE",
      propertyValue: "BILL_PAYMENT"
    });
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "TRANSACTED",
      propertyName: "AMOUNT",
      propertyValue: this.selectedPlan
    });
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "TRANSACTED",
      propertyName: "RESULT",
      propertyValue: "DECLINED"
    });
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "TRANSACTED",
      propertyName: "MESSAGE",
      propertyValue: this.responseMessage.responseDescription
    });
  }
};
</script>
<style lang="scss" scoped>
.section {
  background: #fafafa;
  padding: 20px;
  &__status {
    color: #4d4d4d;
    background: #ffffff;
    padding: 65px 35px;
    text-align: center;
    &__image {
      height: 58px;
    }
    &__title {
      margin-top: 30px;
      font-size: 16px;
      letter-spacing: 0.34px;
    }
    &__subtitle {
      font-size: 16px;
      margin-top: 76px;
      line-height: 1.69;
      letter-spacing: normal;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EplNewTransactionFail.vue